// extracted by mini-css-extract-plugin
module.exports = {"brand-search-info":"BrandSearchInfo_brand-search-info__jGpc_","brand-search-info__cta":"BrandSearchInfo_brand-search-info__cta__vit6m"};